import { useProfileQuery } from 'redux/slices/baseApi';
import { useProfile } from './useProfile';

export const useServerProfile = () => {
  const localProfile = useProfile();
  const { data: profile, isLoading, error } = useProfileQuery(localProfile?.id);
  return { profile, isLoading, error };
};
